import Vue from 'vue';

const success = (response, context) => {
  document.title = response.data.pageTitle;
  context.content = response.data.content;
  context.auth = response.data.auth;
  context.rental_deposit = response.data.booking.rental.deposit;
  context.countries = response.data.countries;
  const userCurrency = response.data.booking.rental.currency ? response.data.booking.rental.currency.symbol : '€'

  if (response.data && response.data.booking && response.data.booking.booking_contract && response.data.booking.booking_contract.id) {
    context.contract = {
      ...response.data.booking.booking_contract,
      checking: response.data.booking.checking,
      checkout: response.data.booking.checkout,
      userCurrency
    };
    context.contract.lessor_phone = response.data.booking.rental.user.phone ? response.data.booking.rental.user.phone: '';
    // context.tenant_signature = response.data.booking.booking_contract.tenant_signature;
    context.tenant_signature = context.api_url + '/images/signatures/' + response.data.booking.booking_contract.tenant_signature.slice(-24);
  } else {
    let lessorFirstName;
    let lessorLastName;

    if (response.data && response.data.booking && response.data.booking.rental) {
      lessorFirstName = response.data.booking.rental.owner_first_name ? response.data.booking.rental.owner_first_name :  response.data.booking.rental.user.first_name;
      lessorLastName = response.data.booking.rental.owner_last_name ? response.data.booking.rental.owner_last_name :  response.data.booking.rental.user.last_name;
    }

    context.contract = {
      booking_id: response.data.booking.id,
      rental_id: response.data.booking.rental.id,
      rental_name: response.data.booking.rental.name,

      rental_address: response.data.booking.rental.address,
      rental_zip_code: response.data.booking.rental.zip_code,
      rental_city: response.data.booking.rental.city,
      rental_country: '',
      address: response.data.booking.rental.address,
      checking: response.data.booking.checking,
      checkout: response.data.booking.checkout,
      nbr_adults: response.data.booking.nbr_adults,
      nbr_children: response.data.booking.nbr_children,
      total: 0,
      nights_fees_total: 0,
      taxes_fees_total: 0,
      cleaning_fees_total: 0,
      optional_fees_total: 0,
      lessor_first_name: lessorFirstName,
      lessor_last_name: lessorLastName,
      lessor_address: response.data.booking.rental.owner_address,
      lessor_zip_code: response.data.booking.rental.owner_post_code,
      lessor_city: response.data.booking.rental.owner_city,
      lessor_country: '',
      lessor_email: response.data.booking.rental.email,
      lessor_phone: response.data.booking.rental.user.phone,

      tenant_first_name: response.data.booking.guest.first_name,
      tenant_last_name: response.data.booking.guest.last_name,

      tenant_address: response.data.booking.guest.address,
      tenant_zip_code: response.data.booking.guest.zip_code,
      tenant_city: response.data.booking.guest.city,
      tenant_country: response.data.booking.guest.country,

      tenant_email: response.data.booking.guest.email,
      tenant_phone: response.data.booking.guest.phone,
      userCurrency
    };
    context.contract.tenant_phone = context.contract.tenant_phone ? context.contract.tenant_phone.toString() : '';
    context.contract.nights_fees_total = response.data.booking.price.toFixed(2);
    context.contract.taxes_fees_total = response.data.booking.city_taxes.toFixed(2);
    context.contract.cleaning_fees_total = response.data.booking.cleaning.toFixed(2);
    context.contract.total = context.getPriceAmount(response.data.booking);

    if (response && response.data && response.data.booking &&
      response.data.booking.rental && response.data.booking.rental.country &&
      response.data.booking.rental.country.name) {
      context.contract.rental_country = response.data.booking.rental.country.name;
      context.contract.lessor_country = response.data.booking.rental.country.name;
    }
  }
  context.getDatePickerLang();
  context.loading = false;
};

// When the request fails
const failed = (error, context) => {
  context.loading = false;
};

export default (permalink, context, send_action = true) => {
  let url = '/booking-contract/' + permalink + '?send_action=' + send_action;
  return Vue.$http.get(url)
    .then((response) => {
      if (response && response.status === 200) {
        success(response, context);
      }
    })
    .catch((error) => {
      if (error) {
        failed(error, context);
      }
    });
};



// WEBPACK FOOTER //
// ./src/app/services/booking/getBookingByPermalik.js